import { Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { ReactNode } from 'react'

const useStyles = makeStyles({
  footer: {
    position: 'fixed',
    bottom: 0,
    right: 0,
    width: '100%',
    backgroundColor: '#757575',
  },
  footerText: {
    color: 'white',
    lineHeight: '36px',
  },
})

const BaseFooter: React.FC<{ children: ReactNode }> = ({ children }) => {
  const classes = useStyles()

  return (
    <footer className={classes.footer}>
      <Grid container item alignItems="center" justifyContent="center">
        <Typography variant="body2" className={classes.footerText}>
          {children}
        </Typography>
      </Grid>
    </footer>
  )
}

export const Footer: React.FC = () => {
  return (
    <BaseFooter>
      Copyright (C) MCD3 Inc. All Rights Reserved.
    </BaseFooter>
  )
}
